module.exports = __webpack_public_path__ + "static/media/delete-red.6fb3ec97.svg";